import "./Home.css"
import React from 'react'
import { motion } from "framer-motion"
import bmwLogo from "../../img/bmw2.png"
import mercedesLogo from "../../img/mercedes2.png"
import porscheLogo from "../../img/porsche2.png"

const Home = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    }

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    return (
        <motion.div 
            className="home-content"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.h1 variants={itemVariants}>
                SOLUÇÕES AUTOMOTIVAS <br /> 
                <span className="highlight">EM SC E SP</span>
            </motion.h1>
            
            <motion.p variants={itemVariants} className="subtitle">
                Assistência técnica especializada em carros importados como 
                <br />
                <strong>Mercedes-Benz, Porsche e BMW.</strong>
            </motion.p>
            
            <motion.div className="brand-logos" variants={itemVariants}>
                <img src={bmwLogo} alt="BMW" />
                <img src={mercedesLogo} alt="Mercedes" className="mercedes" />
                <img src={porscheLogo} alt="Porsche" />
            </motion.div>

            <motion.div variants={itemVariants} className="cta-container">
                <a href="#servicos" className="cta-button">Ver Serviços</a>
            </motion.div>
        </motion.div>
    )
}

export default Home;